<template>
  <div class="row">
    <div
      v-if="is_login"
      class="my-card">
      <div class="header-card"/>
      <div class="body-card p-8">
        <div class="title">Dành riêng cho tuổi của bạn ngày hôm nay</div>
        <div class="tu-van">Trời đất cát hung chuyển mỗi ngày
        Giờ nào xung hợp với ta đây?
        Mỗi người một số làm sao biết?
        Muốn rõ tận tường... <span
          class="btn-tu-van"
          @click="redirectToCoVan()">hãy thử ngay...</span>
        </div>
        <div
          class="LuanGiaiTuoi">
          <div class="intro">
            Căn cứ vào ngày tháng năm sinh của bạn, hệ thống sẽ tự động phân tích và trả kết quả hàng ngày:
            <div><img src="../../assets/img/basic/tick.png">Hôm nay tốt xấu với bạn thế nào ?</div>
            <div><img src="../../assets/img/basic/tick.png">Nên làm gì, không nên làm gì ?</div>
            <div><img src="../../assets/img/basic/tick.png">Giờ nào được việc, giờ nào thì không?</div>
          </div>

          <div class="input-date-group">
            <div class="col-12">
              <div class="row">
                <h6> Nhập ngày tháng năm sinh dương lịch</h6>
              </div>
            </div>
          </div>

          <div class="input-date-group">
            <div class="col-6">
              <div class="row">
                <h6> Ngày sinh:</h6>
              </div>
            </div>

            <select
              v-model="selected_day"
              class="form-control">
              <option
                v-for="d in day"
                class="form-control">{{ d }}</option>
            </select>
          </div>

          <div class="input-date-group">
            <div class="col-6">
              <div class="row">
                <h6> Tháng sinh:</h6>
              </div>
            </div>

            <select
              v-model="selected_mon"
              class="form-control">
              <option
                v-for="m in month"
                class="form-control">{{ m }}</option>
            </select>
          </div>

          <div class="input-date-group">
            <div class="col-6">
              <div class="row">
                <h6> Năm sinh:</h6>
              </div>
            </div>

            <select
              v-model="selected_year"
              class="form-control">
              <option
                v-for="y in year"
                class="form-control">{{ y }}</option>
            </select>
          </div>
          <label
            class="radio"
            hidden>
            Nam
            <input
              v-model="gender"
              class="form-check-input"
              type="radio"
              name="exampleRadios"
              value="1">
            <span class="checkround"/>
          </label>
          <label
            class="radio"
            hidden>
            Nữ
            <input
              v-model="gender"
              class="form-check-input"
              type="radio"
              name="exampleRadios"
              value="2">
            <span class="checkround"/>
          </label>

          <button
            :disabled="!date"
            type="button"
            class="btn mt-4 btn-success col-12"
            @click="redirectToCoVan()">LUẬN GIẢI CHI TIẾT
          </button>
        </div>

      </div>
    </div>
    <div
      v-if="serviceHots.length > 0"
      class="my-card">
      <div class="header-card">
        <div class="header-card-left pull-left text-bold">Tài lộc - Vận hạn 2021</div>
        <div class="header-card-right pull-right">
          <!--<router-link to="/course">Xem thêm</router-link>-->
        </div>
        <div class="clearfix"/>
      </div>
      <div class="col-12">
        <div class="row row-cols-4 row-cols-sm-4 h-100">
          <div
            v-for="service in serviceHots"
            class="card text-center">
            <service-item :item="service"/>
          </div>
        </div>
      </div>

    </div>
    <div class="my-card">
      <div class="header-card">
        <div class="header-card-left pull-left text-bold">Cố vấn phong thuỷ</div>
        <div class="header-card-right pull-right">
          <router-link to="/services">Xem thêm</router-link>
        </div>
        <div class="clearfix"/>
      </div>
      <div class="col-12 bg-white">
        <div class="row row-cols-4 row-cols-sm-4 h-100">
          <div
            v-for="covan in services"
            class="card text-center">
            <service-item :item="covan"/>
          </div>
        </div>
      </div>
    </div>
    <div class="my-card">
      <div class="header-card">
        <div class="header-card-left pull-left text-bold">Vật phẩm phong thuỷ</div>
        <div class="header-card-right pull-right">
          <router-link to="/categories">Xem thêm</router-link>
        </div>
        <div class="clearfix"/>
      </div>
      <div class="col-12 bg-white">
        <div class="row row-cols-4 row-cols-sm-4 h-100">
          <div
            v-for="category in categories"
            class="card text-center">
            <item-category :item="category"/>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="boiVui.length > 0"
      class="my-card">
      <div class="header-card">
        <div class="header-card-left pull-left text-bold">Bói vui - Chiêm đoán</div>
        <div class="header-card-right pull-right"/>
        <div class="clearfix"/>
      </div>
      <div class="col-12 bg-white">
        <div class="row row-cols-4 row-cols-sm-4 h-100">
          <div
            v-for="service in boiVui"
            class="card text-center">
            <service-item :item="service"/>
          </div>
        </div>
      </div>
    </div>
    <br>
    <suggest-buy-package/>
  </div>

</template>
<script>
    import carousel from 'vue-owl-carousel'
    import ItemCategory from './ItemCategory'
    import ServiceCategory from './ServiceCategory'
    import rf from '../../communicate/RequestFactory'
    import {infoToaster, successToaster} from '../../services/ErrorHandler'
    import CourseItem from '../course/CourseItem'
    import ServiceItem from '../service/ServiceItem'
    import Flickity from 'vue-flickity'
    import {getCurrentUser, isLoggedIn, setCurrentUser, setDob, setPhone, setToken} from '../../services/authService'
    import SuccessBuyPackage from "./SuccessBuyPackage";
    import SuggestBuyPackage from "./SuggestBuyPackage";
    import ServiceItemPaid from '../service/ServiceItemPaid'
    import Dv from '../../communicate/DichVuType';
    import ServiceHot from '../service/ServiceHot'

    export default {
        name: 'Home', // id of the layout
        components: {
            SuggestBuyPackage,
            SuccessBuyPackage,
            ServiceItem,
            ServiceItemPaid,
            ServiceHot,
            CourseItem,
            carousel: carousel,
            ItemCategory,
            Flickity,
            ServiceCategory
        },

        data: function () {
            return {
                is_login: false,
                categories: [],
                serviceHots: [],
                boiVui: [],
                khamPha: [],
                studies: [],
                services: [],
                articles: [],
                flickityOptions: {
                    initialIndex: 3,
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    freeScroll: true,
                    autoPlay: 3000
                },
                is_success: false,
                error_code: this.$route.query.error_code,
                payment_status: this.$route.query.payment_status,
                phone: this.$route.query.msisdn,
                time: this.$route.query.time,
                url_payment: this.$route.query.url_payment,
                merchant_code: this.$route.query.merchant_code,
                check_sum: this.$route.query.check_sum,
                prevRoute: null,
                user: null,
                date: new Date().toISOString(),
                gender: 1,
                day: [],
                month: [],
                year: [],
                selected_day: new Date().getDate(),
                selected_mon: new Date().getMonth() + 1,
                selected_year: new Date().getFullYear(),
                is_paid_house: false,
                is_kloc: false
            }
        },
        mounted() {
            this.date = new Date();
            this.date.setFullYear(new Date().getFullYear() - 20);
            // this.date = this.date.toISOString();
            this.selected_year = this.date.getFullYear();
            this.selected_mon = this.date.getMonth();
            this.selected_day = this.date.getDate();

            this.is_login = isLoggedIn();
            this.user = getCurrentUser();
            this.phone = this.$route.query.msisdn;
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            if (!this.phone) {
              this.phone = params.get("msisdn");
              this.time = params.get("time");
              this.url_payment = params.get("url_payment");
              this.merchant_code = params.get("merchant_code");
              this.phone = params.get("msisdn");
            }
            if (!this.payment_status) {
                this.payment_status = params.get("payment_status");
                this.check_sum = params.get("check_sum");
            }

            if (this.phone !== undefined && this.phone !== '') {
                this.loginPhongThuy()
            }
            this.loadHome()
            if (this.error_code) {
                this.getContentTransfer()
            }
            for (let i = 1; i <= 31; i++) {
              this.day.push(i);
            }
            for (let i = 1; i <= 12; i++) {
              this.month.push(i);
            }
            for (let i = 1940; i < 2030; i++) {
              this.year.push(i);
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from.path;
                if (from.path === '/luan-giai-tuoi' && vm.is_login && vm.user && vm.user.free_account)
                vm.$bvModal.show('suggest_buy_package');
            })
        },
        methods: {

            getContentTransfer() {
                switch (this.error_code) {
                    case '22':
                        this.message = 'Khách hàng nhập sai OTP'
                        break
                    case '00':
                        this.message = 'Giao dịch thành công'
                        this.is_success = true
                        break
                    default:
                        this.message = ''
                        break;
                }

                if (this.is_success) {
                    successToaster('Cố vấn Phong Thủy', this.message)
                }
            },

            loadHome() {
                this.$Progress.start()
                rf.getRequest('HomeRequest').loadHomeContent().then((res) => {
                    console.log(res.data)
                    this.categories = res.data.group_item
                    this.services = res.data.services
                    this.serviceHots = res.data.hot_service
                    this.boiVui = res.data.boi_vui
                    this.studies = res.data.study
                    this.khamPha = res.data.knowledge
                    if(this.is_login)
                      this.detectPaidService();
                    this.$Progress.finish()
                }).catch(err => {
                    infoToaster('Xảy ra lỗi', 'Hệ thống đang bảo dưỡng')
                    this.$Progress.fail()
                })
            },

            detectPaidService() {
              if (this.services) {
                this.services.forEach(item => {
                  if (item.id === Dv.KICH_TAI_LOC) {
                    this.is_kloc = item.buy_success;
                  }
                  if (item.id === Dv.NHA_O) {
                    this.is_paid_house = item.buy_success;
                  }
                })
              }
            },

          loginPhongThuy() {
            this.$Progress.start()
            const user = {
              phone: this.phone,
              time: this.time,
              url_payment: this.url_payment,
              check_sum: this.check_sum,
              merchant_code: this.merchant_code,
            }

            rf.getRequest('LoginRequest').login_auto(user).then((res) => {
              this.$Progress.finish()
              if (res.status === 200) {
                const data = res.data
                setCurrentUser(data)
                setToken(data.token);
                setPhone(this.phone);
                this.loadServices();
                this.is_login = true;
                this.$router.push(this.$route.query.from || '/')
              }
            }).catch(err => {
              console.log(err)
              this.$Progress.fail()
            })
          },

            loadServices() {
              rf.getRequest("ServiceRequest").loadTotalServices().then((res) => {
                if (res.status === 200) {
                  this.services = res.data;
                  this.detectPaidService();
                }
              }).catch(err => {
              })
            },

            redirectToCoVan() {
                let date = new Date(this.selected_year, this.selected_mon - 1, this.selected_day, 0, 0 , 0);
                this.$router.push('luan-giai-tuoi?birthDay='+date);
            },

            content(event) {
              if (event.id === Dv.KICH_TAI_LOC) {
                this.$router.push('tai_loc/content');
              } else if (event.id === Dv.NHA_O) {
                this.$router.push('nha_o/content');
              }
            },

            gotoService(type) {
              if (type === Dv.KICH_TAI_LOC) {
                this.$router.push('tai_loc/content');
              } else if (type === Dv.NHA_O) {
                this.$router.push('nha_o/content');
              }
            }
        }
    }
</script>
<style lang="scss" scoped>
  .card {
    width: 100%;
  }
  .card img {
    max-height: 100px;
    height: 100px;
    border-bottom: 1px solid #e2e3e5;
  }
  .card-title {
    font-size: 12px;
    color: #000;
    text-align: center;
  }

  .thumbnail {
    margin: 5px;
    border: none;

  }

  .card {
    margin-bottom: 0;
    border-radius: 0;
  }

  .card-img-top {
    border-radius: 0;
  }

  .border-service {
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
  }

  .carousel-cell {
    width: 66%;
    height: 300px;
    margin-right: 10px;
    background: white;
    border-radius: 5px;
  }

  .text-bold {
    font-weight: bold;
  }

  .p-8 {
    padding: 8px;
  }

  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    width: 100%;
  }

  hr {
    border: 1px solid #EFEFEF;
    width: 100%;
  }

  .tu-van {
    margin-top: 10px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    white-space: pre-line;
    color: #5E6372;

    .btn-tu-van {
      font-weight: 600;
      cursor: pointer;
    }
  }

  .btn-luan-giai {
    font-style: normal;
    font-weight: 600;
    font-size: 11px;
    color: #008F0C;
    width: 100%;
    text-align: right;

    img {
      margin-left: 5px;
    }

  }


  .LuanGiaiTuoi {
    background-color: white;

    .title {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
    }

    .intro {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #3B485B;
      margin-top: 18px;
      line-height: 23px;

      div {
        img {
          margin-right: 5px;
        }
      }
    }

    .input-date-group {
      position: relative;
      width: 100%;
      top: 15px;
      img {
        position: absolute;
        top: 37px;
        right: 5px;
      }
    }

    & /deep/ .vdatetime {
      width: 100%;
    }


    & /deep/ .input-date {
      height: 46px;
      line-height: 46px;
      margin-top: 0px;
      background: rgba(17, 202, 113, 0.18);
      width: 100%;
      border-radius: 5px;
      border: none;
      padding: 10px 30px 10px 10px;
      font-weight: 600;
      font-size: 16px;

      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        opacity: 1;
        color: #3B485B;
      }

      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #3B485B;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
      }

      ::-ms-input-placeholder { /* Microsoft Edge */
        color: #3B485B;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
      }
    }

    & /deep/ .input-date::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      font-weight: 600;
      font-size: 16px;
      opacity: 1;
      color: #3B485B;
    }

    & /deep/ .input-date:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #3B485B;
      font-weight: 600;
      font-size: 16px;
    }

    & /deep/ .input-date::-ms-input-placeholder { /* Microsoft Edge */
      color: #3B485B;
      font-weight: 600;
      font-size: 16px;
    }

    & /deep/ .input-date::after {
      content: "Ngày sinh";
    }

    .radio {
      margin-right: 16px;
      margin-top: 16px;
    }

    & /deep/ .theme-green .vdatetime-popup__header,
    .theme-green .vdatetime-calendar__month__day--selected > span > span,
    .theme-green .vdatetime-calendar__month__day--selected:hover > span > span {
      background: #49AF4C;
    }

    & /deep/ .theme-green .vdatetime-year-picker__item--selected,
    .theme-green .vdatetime-time-picker__item--selected,
    .theme-green .vdatetime-popup__actions__button {
      color: #49AF4C;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue